/** Items per page configuration */
export const MD_TILES_PER_PAGE = 6;
export const SM_TILES_PER_PAGE = 12;

/**
 * Gets items per page based on tile size
 * @param {string} tileSize - Tile size ('medium' or 'small')
 * @returns {number} Items per page
 */
export const getItemsPerPage = (tileSize) => {
	return tileSize === 'small' ? SM_TILES_PER_PAGE : MD_TILES_PER_PAGE;
};

/**
 * Return true if paging is needed.
 * Paging isn't needed if there is no data (totalCount === 0)
 * or if the total count is less than the page size
 * @param {Object} paging - Paging object with totalCount and pageSize
 * @returns {boolean}
 */
export const isPagingNeeded = (paging) => {
	return (
		paging && paging.totalCount !== 0 && paging.totalCount > paging.pageSize
	);
};

/**
 * Slices data array for current page based on offset and pageSize
 * @param {Array} data - Full dataset
 * @param {number} offset - Starting index (0-based)
 * @param {number} pageSize - Items per page
 * @returns {Array} Paginated data slice
 */
export const paginateData = (data, offset, pageSize) => {
	if (!Array.isArray(data)) {
		return [];
	}

	const endIndex = Math.min(offset + pageSize, data.length);
	return data.slice(offset, endIndex);
};
